export const fontWeight = {
  regular: 400,
  bold: 700,
};
